/**
 * Closes a domain driven slider.
 */
export function closePagePopover() {
  Bus.$emit("closePopover1");
}

/**
 * Closes a static non-domain driven slider.
 */
export function closeStaticPopover() {
  Bus.$emit("closePopover2");
}
